// extracted by mini-css-extract-plugin
module.exports = {"trigger":"TriggerIcon_trigger_2V4Ig"};